import { c as Pe } from "react/compiler-runtime";
import { useState as Ne } from "react";
const r = () => ({
  previewUrl: "",
  imageName: "",
  imageSize: 0
}), ge = (n, i, I = [], h = !1, e) => {
  if (!i)
    return {
      isValid: !0
    };
  const o = n.trim();
  return o ? o.length < 2 ? {
    isValid: !1,
    error: "Plan name must be at least 2 characters long"
  } : o.length > 40 ? {
    isValid: !1,
    error: "Plan name cannot exceed 40 characters"
  } : (!h || e && o !== e) && I.some((g) => g.planName.toLowerCase().trim() === o.toLowerCase()) ? {
    isValid: !1,
    error: "A plan with this name already exists"
  } : /^[a-zA-Z0-9\s\-_]+$/.test(o) ? {
    isValid: !0
  } : {
    isValid: !1,
    error: "Plan name can only contain letters, numbers, spaces, hyphens, and underscores"
  } : {
    isValid: !1,
    error: "Custom plan name is required"
  };
}, De = (n, i, I, h) => {
  const e = Pe(70);
  let o;
  e[0] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (o = {
    floorPlan: r(),
    rfPlan: r(),
    sinrPlan: r(),
    dominantCellPlan: r(),
    customPlan: r(),
    customPlanName: "",
    customPlanNameTouched: !1,
    targetCustomPlanName: null,
    targetCustomPlanIndex: null,
    targetCustomImageId: null,
    mode: "NEW_OVERLAY",
    editingOverlayId: null,
    isOpen: !1
  }, e[0] = o) : o = e[0];
  const [t, P] = Ne(o);
  let g;
  e[1] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (g = (m) => ({
    setName: (l) => P((a) => ({
      ...a,
      [m]: {
        ...a[m],
        imageName: l
      }
    })),
    setSize: (l) => P((a) => ({
      ...a,
      [m]: {
        ...a[m],
        imageSize: l
      }
    })),
    setPreviewUrl: (l) => P((a) => ({
      ...a,
      [m]: {
        ...a[m],
        previewUrl: l
      }
    }))
  }), e[1] = g) : g = e[1];
  const O = g;
  let p;
  e[2] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (p = O("floorPlan"), e[2] = p) : p = e[2];
  const le = p;
  let x;
  e[3] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (x = O("rfPlan"), e[3] = x) : x = e[3];
  const ne = x;
  let F;
  e[4] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (F = O("sinrPlan"), e[4] = F) : F = e[4];
  const ie = F;
  let U;
  e[5] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (U = O("dominantCellPlan"), e[5] = U) : U = e[5];
  const me = U;
  let V;
  e[6] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (V = O("customPlan"), e[6] = V) : V = e[6];
  const oe = V;
  let w;
  e[7] !== n ? (w = (m, l) => {
    if (!l)
      return null;
    const a = n.find((D) => D.id === l);
    if (!a?.plan?.calibrationPoints)
      return null;
    switch (m) {
      case "ADD_FLOOR_PLAN":
        return a.plan.calibrationPoints.floorPlan || null;
      case "ADD_RF_PLAN":
        return a.plan.calibrationPoints.rfPlan || null;
      case "ADD_SINR_PLAN":
        return a.plan.calibrationPoints.sinrPlan || null;
      case "ADD_DOMINANT_CELL_PLAN":
        return a.plan.calibrationPoints.dominantCellPlan || null;
      default:
        return null;
    }
  }, e[7] = n, e[8] = w) : w = e[8];
  const j = w;
  let E;
  e[9] !== n || e[10] !== t.customPlanName || e[11] !== t.editingOverlayId || e[12] !== t.mode || e[13] !== t.targetCustomImageId || e[14] !== t.targetCustomPlanIndex || e[15] !== t.targetCustomPlanName ? (E = () => {
    if (t.mode !== "ADD_CUSTOM_PLAN")
      return null;
    const l = (n.find((L) => L.id === t.editingOverlayId) || n[0])?.plan?.calibrationPoints?.customPlan || [];
    let a = t.targetCustomImageId ? l.find((L) => L.imagesInfo?.imageId === t.targetCustomImageId) : void 0;
    if (!a && typeof t.targetCustomPlanIndex == "number" && t.targetCustomPlanIndex >= 0 && (a = l[t.targetCustomPlanIndex]), !a) {
      const L = (t.targetCustomPlanName || "").trim();
      a = L ? l.find((de) => de.planName === L) : void 0;
    }
    const D = a?.planName || (t.customPlanName || t.targetCustomPlanName || "").trim();
    return a ? {
      imageData: a.imagesInfo?.imageData,
      imageName: a.imagesInfo?.imageName,
      planName: a.planName
    } : D ? {
      planName: D
    } : null;
  }, e[9] = n, e[10] = t.customPlanName, e[11] = t.editingOverlayId, e[12] = t.mode, e[13] = t.targetCustomImageId, e[14] = t.targetCustomPlanIndex, e[15] = t.targetCustomPlanName, e[16] = E) : E = e[16];
  const G = E, S = t.mode === "ADD_FLOOR_PLAN", b = t.mode === "ADD_RF_PLAN", R = t.mode === "ADD_SINR_PLAN", y = t.mode === "ADD_DOMINANT_CELL_PLAN", c = t.mode === "ADD_CUSTOM_PLAN", T = S ? "Floor" : b ? "RF" : R ? "SINR" : y ? "Dominant Cell" : "Custom";
  let M;
  e[17] !== I || e[18] !== y || e[19] !== S || e[20] !== b || e[21] !== R || e[22] !== i.CUSTOM_PLAN || e[23] !== i.DOMINANT_CELL_PLAN || e[24] !== i.FLOOR_PLAN || e[25] !== i.RF_PLAN || e[26] !== i.SINR_PLAN || e[27] !== h ? (M = S ? i.FLOOR_PLAN.icon(I) : b ? i.RF_PLAN.icon(h) : R ? i.SINR_PLAN?.icon?.() : y ? i.DOMINANT_CELL_PLAN?.icon?.() : i.CUSTOM_PLAN?.icon?.(), e[17] = I, e[18] = y, e[19] = S, e[20] = b, e[21] = R, e[22] = i.CUSTOM_PLAN, e[23] = i.DOMINANT_CELL_PLAN, e[24] = i.FLOOR_PLAN, e[25] = i.RF_PLAN, e[26] = i.SINR_PLAN, e[27] = h, e[28] = M) : M = e[28];
  const J = M, s = S ? t.floorPlan : b ? t.rfPlan : R ? t.sinrPlan : y ? t.dominantCellPlan : t.customPlan;
  let v, f, _, u, N, C, H;
  if (e[29] !== s.imageName || e[30] !== s.previewUrl || e[31] !== G || e[32] !== j || e[33] !== c || e[34] !== n || e[35] !== t.customPlanName || e[36] !== t.editingOverlayId || e[37] !== t.mode) {
    u = c ? G() : j(t.mode, t.editingOverlayId), N = !!u?.imageData, _ = s.previewUrl || u?.imageData || "", f = s.imageName || u?.imageName || "", C = c && N, v = c ? u : null;
    const l = (n.find((a) => a.id === t.editingOverlayId) || n[0])?.plan?.calibrationPoints?.customPlan || [];
    H = ge(t.customPlanName, c, l, C, v?.planName), e[29] = s.imageName, e[30] = s.previewUrl, e[31] = G, e[32] = j, e[33] = c, e[34] = n, e[35] = t.customPlanName, e[36] = t.editingOverlayId, e[37] = t.mode, e[38] = v, e[39] = f, e[40] = _, e[41] = u, e[42] = N, e[43] = C, e[44] = H;
  } else
    v = e[38], f = e[39], _ = e[40], u = e[41], N = e[42], C = e[43], H = e[44];
  const d = H, K = c ? C ? !d.isValid : !s.previewUrl || !d.isValid : !s.previewUrl, Q = c ? C ? `Edit ${v?.planName || t.customPlanName || "Custom Plan"}` : "Add Custom Plan" : `${N ? "Replace" : "Add"} ${T} Plan`, X = u?.imageData, ee = u?.imageName, te = c && t.customPlanNameTouched && !d.isValid;
  let A;
  e[45] !== te || e[46] !== d.error || e[47] !== d.isValid ? (A = {
    customPlanNameError: d.error,
    isValid: d.isValid,
    showError: te
  }, e[45] = te, e[46] = d.error, e[47] = d.isValid, e[48] = A) : A = e[48];
  let $;
  e[49] !== s || e[50] !== Q || e[51] !== f || e[52] !== _ || e[53] !== N || e[54] !== J || e[55] !== T || e[56] !== K || e[57] !== X || e[58] !== ee || e[59] !== A ? ($ = {
    planType: T,
    icon: J,
    hasExistingData: N,
    existingImageData: X,
    existingImageName: ee,
    currentFileData: s,
    displayPreviewUrl: _,
    displayImageName: f,
    shouldDisableSubmit: K,
    dialogTitle: Q,
    validation: A
  }, e[49] = s, e[50] = Q, e[51] = f, e[52] = _, e[53] = N, e[54] = J, e[55] = T, e[56] = K, e[57] = X, e[58] = ee, e[59] = A, e[60] = $) : $ = e[60];
  const ae = $;
  let z;
  e[61] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (z = (m, l, a) => {
    P((D) => ({
      ...D,
      mode: m,
      editingOverlayId: l,
      isOpen: !0,
      targetCustomPlanName: a?.targetName || null,
      targetCustomPlanIndex: a?.targetIndex || null,
      targetCustomImageId: a?.targetImageId || null,
      customPlanName: a?.targetName || ""
    }));
  }, e[61] = z) : z = e[61];
  const se = z;
  let k;
  e[62] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (k = () => {
    P(fe);
  }, e[62] = k) : k = e[62];
  const re = k;
  let q;
  e[63] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (q = (m) => {
    P((l) => ({
      ...l,
      customPlanName: m
    }));
  }, e[63] = q) : q = e[63];
  const ce = q;
  let B;
  e[64] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (B = () => {
    P(_e);
  }, e[64] = B) : B = e[64];
  const ue = B;
  let W, Y;
  e[65] === /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel") ? (W = {
    floorPlan: le,
    rfPlan: ne,
    sinrPlan: ie,
    dominantCellPlan: me,
    customPlan: oe
  }, Y = {
    openDialog: se,
    closeDialog: re,
    setCustomPlanName: ce,
    markCustomPlanNameTouched: ue
  }, e[65] = W, e[66] = Y) : (W = e[65], Y = e[66]);
  let Z;
  return e[67] !== ae || e[68] !== t ? (Z = {
    state: t,
    planInfo: ae,
    handlers: W,
    actions: Y
  }, e[67] = ae, e[68] = t, e[69] = Z) : Z = e[69], Z;
};
function fe(n) {
  return {
    ...n,
    isOpen: !1,
    floorPlan: r(),
    rfPlan: r(),
    sinrPlan: r(),
    dominantCellPlan: r(),
    customPlan: r(),
    customPlanName: "",
    customPlanNameTouched: !1,
    targetCustomPlanName: null,
    targetCustomPlanIndex: null,
    targetCustomImageId: null,
    editingOverlayId: null
  };
}
function _e(n) {
  return {
    ...n,
    customPlanNameTouched: !0
  };
}
export {
  De as useUploadDialog
};
